import { render, staticRenderFns } from "./exchange-rate.vue?vue&type=template&id=05a78fbc"
import script from "./exchange-rate.vue?vue&type=script&lang=js"
export * from "./exchange-rate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports